var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRevenuesSecondary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 42.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.75,57.5a50,50,0,1,0-50-50,50,50,0,0,0,50,50",
    transform: "translate(21.25)",
    fill: "#fcaa3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,25.641l4.875-3.247a.95.95,0,0,1,1.332.287l8.456,13.532a.949.949,0,0,1-.318,1.318l-3.908,2.341M24.668,23.742H36.054a3.794,3.794,0,1,0,0-7.588H20.7a5.686,5.686,0,0,0-3.158.955L7.082,24.081m30.252-.562,16.242-6.1a3.8,3.8,0,1,1,2.906,7.012l-16.758,7.1a9.48,9.48,0,0,1-3.7.753H21.249a5.688,5.688,0,0,0-3.129.936L14.346,35.7m6.3-23.344A19.827,19.827,0,0,1,17.078.973a19.925,19.925,0,0,1,39.849,0,19.844,19.844,0,0,1-4.278,12.334M31.308,6.664a5.057,5.057,0,0,0,4.271,2.847h2.847a4.269,4.269,0,0,0,0-8.539H35.579A4.282,4.282,0,0,1,31.308-3.3a4.284,4.284,0,0,1,4.271-4.271h2.847a5.054,5.054,0,0,1,4.268,2.847M37-10.413v2.847M37,9.512v2.847",
    transform: "translate(17.527 -2.96)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenuesSecondary);
export default __webpack_public_path__ + "static/media/revenues-secondary.c8aa79ee658cb9237bd61bd3cd8721de.svg";
export { ForwardRef as ReactComponent };